<template lang="pug">
transition(
  :css="false"
  @before-enter="beforeEnter"
  @enter="enter"
  @leave="leave"
)
  slot
</template>

<script setup lang="ts">
import useAnimatedTransition from '../lib/useAnimatedTransition';

const props = withDefaults(
  defineProps<{
    delay?: number;
    rotate?: number;
    duration?: number;
  }>(),
  {
    delay: 0,
    rotate: 0,
    duration: 0.5
  }
);

const { beforeEnter, leave, enter } = useAnimatedTransition(props);
</script>
